import PlatformActions from './PlatformActions'

export default class ODINActions extends PlatformActions {
  constructor(formData) {
    super(formData)
    this.formData = formData

    this.constantTxnData = {
      gameType: 'SLOT',
      gameName: 'Deep Sea Adventure',
      gameCode: 'ODIN-SLOT-006',
      platform: 'ODIN',
    }
  }

  getBetNSettleMessage(txnList) {
    const { currency, supportPremium } = this.formData

    const txns = txnList.map(({
      userId,
      txnId,
      betTime,
      betAmount,
      turnover,
      winAmount,
      jackpotWinAmount,
      updateTime,
    }) => ({
      ...this.constantTxnData,
      userId,
      platformTxId: `${txnId}_806330129_pq_shenhaiqiyu`, // 17667405990720516897_806330129_pq_shenhaiqiyu
      roundId: `${txnId}_806330129_pq_shenhaiqiyu`, // 17667405990720516897_806330129_pq_shenhaiqiyu
      betType: null,
      currency,
      betTime, // 2025-12-26T17:16:39.000+08:00
      txTime: betTime,
      betAmount,
      turnover,
      winAmount,
      jackpotBetAmount: 0,
      jackpotWinAmount: jackpotWinAmount ?? 0,
      updateTime, // 2021-11-27T08:56:09.939+08:00
      requireAmount: betAmount,
      gameInfo: {},
      ...(supportPremium && { isPremium: false }),
    }))

    const message = {
      action: 'betNSettle',
      txns,
    }

    return JSON.stringify(message)
  }

  getCancelBetNSettleMessage(txnList) {
    const txns = txnList.map(({
      userId,
      txnId,
      betAmount,
      updateTime,
    }) => ({
      ...this.constantTxnData,
      userId,
      platformTxId: `${txnId}_806330129_pq_shenhaiqiyu`,
      roundId: `${txnId}_806330129_pq_shenhaiqiyu`,
      updateTime,
      betAmount,
      gameInfo: {},
    }))

    const message = {
      action: 'cancelBetNSettle',
      txns,
    }

    return JSON.stringify(message)
  }
}
